import { Stack } from '@mui/material';
import React from 'react';

import { CloseIcon } from '@/shared/assets/icons/close-icon';
import { ItemsCountBadge } from '@/shared/components/ui/tabs/components/items-count-badge/items-count-badge';
import { StyledTab } from '@/shared/components/ui/tabs/components/tab/tab.styled';
import { TTabProps } from '@/shared/components/ui/tabs/components/tab/tab.types';
import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';

export const Tab: React.FC<TTabProps> = ({
  label,
  icon,
  itemsCount,
  onClose,
  maxLength = 20,
  additionalInfo,
  ...props
}) => {
  const _onClose = (event: React.BaseSyntheticEvent) => {
    event.stopPropagation();
    onClose?.();
  };

  const renderAdditionalInfo = () => {
    if (!React.isValidElement(additionalInfo)) {
      return additionalInfo;
    }

    const existingClassName = (additionalInfo.props as any)?.className || '';
    const className = `${existingClassName} tab-additional-info`.trim();

    return React.cloneElement(additionalInfo as React.ReactElement<any>, {
      className,
    });
  };

  return (
    <StyledTab
      {...props}
      label={
        <Stack
          direction="row"
          alignItems="center"
          gap="0.375rem"
          paddingX="0.5rem"
        >
          {icon}
          <TruncatedText text={label} variant="p7" maxLength={maxLength} />
          <ItemsCountBadge itemsCount={itemsCount} truncateAt={99} />
          {renderAdditionalInfo()}
          {onClose && <CloseIcon className="close-icon" onClick={_onClose} />}
        </Stack>
      }
    />
  );
};
